/* ============================================================
   SMARTCUBES — produktside v27
   v24: tre købsvalg (enkelt bakke, Duo, Complete), forudbestilling
   og fjerde størrelse (6 rum · 150 ml) i størrelsessektionen.
   v25: Duo-siden (data-duo-page) bruger samme vælger på egne varianter.
   v26: swipe mellem billederne på mobil.
   v27: galleriet viser kun billeder, der hører til den valgte farve.
   ============================================================ */
(function () {
  'use strict';

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  function keyOf(val) {
    var m = String(val || '').trim().match(/^(\d)/);
    return m ? m[1] : null;
  }

  /* "2×500 + 3×350 ml" -> "2+3" */
  function comboKey(val) {
    var out = [], re = /(\d)\s*[\u00d7x]/g, m;
    while ((m = re.exec(String(val || '')))) out.push(m[1]);
    return out.sort().join('+');
  }

  function shortSize(val) {
    var parts = String(val || '').split('\u00b7');
    return (parts[1] || parts[0]).trim();
  }

  function init(root) {
    if (root.getAttribute('data-scp-ready') === '1') return;
    root.setAttribute('data-scp-ready', '1');

    var data, bundleData, duoData, cfgImg;
    try { data = JSON.parse(root.getAttribute('data-variants') || '[]'); } catch (e) { data = []; }
    try { bundleData = JSON.parse(root.getAttribute('data-bundle') || '[]'); } catch (e) { bundleData = []; }
    try { duoData = JSON.parse(root.getAttribute('data-duo') || '[]'); } catch (e) { duoData = []; }
    var duoPage = root.getAttribute('data-duo-page') === '1';
    if (duoPage) duoData = data;
    try { cfgImg = JSON.parse(root.getAttribute('data-cfg-img') || '{}'); } catch (e) { cfgImg = {}; }
    duoData.forEach(function (d) { d.key = comboKey(d.opts[0]); });

    var bundleTitle = root.getAttribute('data-bundle-title') || 'Complete';
    var duoTitle = root.getAttribute('data-duo-title') || 'Duo';
    var productTitle = root.getAttribute('data-title') || '';
    var preorder = root.getAttribute('data-preorder') === '1';
    var addLabel = preorder ? (root.getAttribute('data-po-label') || 'Forudbestil') : 'L\u00e6g i kurv';
    var allowPick = root.getAttribute('data-pick') === '1';

    var idInput = root.querySelector('[data-scp-variant-id]');
    var priceEl = root.querySelector('[data-scp-price]');
    var addText = root.querySelector('[data-scp-add-text]');
    var addPrice = root.querySelector('[data-scp-add-price]');
    var addBtn = root.querySelector('[data-scp-add]');
    var countNow = root.querySelector('[data-scp-count-now]');
    var countAll = root.querySelector('[data-scp-count-all]');
    var singlePrice = root.querySelector('[data-scp-single-price]');
    var groups = root.querySelectorAll('[data-scp-group]');
    var sizeGroup = root.querySelector('[data-size-group]');
    var colourGroup = root.querySelector('[data-colour-group]');
    var sizeNote = root.querySelector('[data-size-note]');
    var duoNote = root.querySelector('[data-duo-note]');
    var stockNote = root.querySelector('[data-scp-stock-note]');

    var duoPicks = [];
    var prevMode = 'single';

    function fmt(p) {
      return (p / 100).toLocaleString('da-DK', { minimumFractionDigits: 2 }) + ' kr';
    }

    function chosen() {
      var out = [];
      each(groups, function (g) {
        var b = g.querySelector('button.active[data-val]');
        out.push(b ? b.getAttribute('data-val') : null);
        var lab = g.querySelector('[data-optvalue]');
        if (lab && b) lab.textContent = b.getAttribute('data-val');
      });
      return out;
    }

    function findIn(list, sel) {
      for (var i = 0; i < list.length; i++) {
        var ok = true;
        for (var j = 0; j < sel.length; j++) {
          if (list[i].opts[j] !== sel[j]) { ok = false; break; }
        }
        if (ok) return list[i];
      }
      return null;
    }

    function colourValue() {
      if (!colourGroup) return null;
      var b = colourGroup.querySelector('button.active[data-val]');
      return b ? b.getAttribute('data-val') : null;
    }

    function activeSizeVal() {
      if (!sizeGroup) return null;
      var b = sizeGroup.querySelector('button.active[data-val]');
      return b ? b.getAttribute('data-val') : null;
    }

    function offerMode() {
      if (duoPage) return 'duo';
      var c = root.querySelector('.scp-offers input:checked');
      return c ? c.getAttribute('data-offer') : 'single';
    }

    /* Complete i den valgte farve — også hvis den er udsolgt, så kunden
       aldrig får en anden farve i kurven end den, der er valgt. */
    function bundleVariant() {
      if (!bundleData.length) return null;
      var want = colourValue(), i;
      if (want) {
        for (i = 0; i < bundleData.length; i++) {
          if (bundleData[i].opts.indexOf(want) !== -1) return bundleData[i];
        }
      }
      for (i = 0; i < bundleData.length; i++) { if (bundleData[i].available) return bundleData[i]; }
      return bundleData[0];
    }

    function duoKey() {
      if (duoPicks.length !== 2) return null;
      return duoPicks.map(keyOf).sort().join('+');
    }

    function duoVariant() {
      var k = duoKey();
      if (!k) return null;
      var want = colourValue();
      for (var i = 0; i < duoData.length; i++) {
        if (duoData[i].key === k && (!want || duoData[i].opts.indexOf(want) !== -1)) return duoData[i];
      }
      return null;
    }

    function groupIndex(g) { return g ? Array.prototype.indexOf.call(groups, g) : -1; }

    function findBtn(g, val) {
      var hit = null;
      each(g.querySelectorAll('button[data-val]'), function (x) {
        if (!hit && x.getAttribute('data-val') === val) hit = x;
      });
      return hit;
    }

    function selectValue(g, val) {
      each(g.querySelectorAll('button[data-val]'), function (x) {
        var on = x.getAttribute('data-val') === val;
        x.classList.toggle('active', on);
        x.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function sortedPicks() {
      return duoPicks.slice().sort(function (x, y) { return keyOf(x) - keyOf(y); });
    }

    function paintDuo() {
      if (!sizeGroup) return;
      each(sizeGroup.querySelectorAll('button[data-val]'), function (x) {
        var on = duoPicks.indexOf(x.getAttribute('data-val')) !== -1;
        x.classList.toggle('active', on);
        x.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    /* ---------- Lagerstatus ---------- */

    function valueAvailable(gi, val, sel, mode) {
      var i, j, v, ok, d;
      if (mode === 'bundle' && groups[gi] === colourGroup) {
        for (i = 0; i < bundleData.length; i++) {
          if (bundleData[i].available && bundleData[i].opts.indexOf(val) !== -1) return true;
        }
        return false;
      }
      if (mode === 'duo' && groups[gi] === colourGroup) {
        var k = duoKey();
        for (i = 0; i < duoData.length; i++) {
          d = duoData[i];
          if (d.available && d.opts.indexOf(val) !== -1 && (!k || d.key === k)) return true;
        }
        return false;
      }
      if (mode === 'duo' && groups[gi] === sizeGroup) {
        var kv = keyOf(val), c = colourValue();
        for (i = 0; i < duoData.length; i++) {
          d = duoData[i];
          if (d.available && d.key.split('+').indexOf(kv) !== -1 && (!c || d.opts.indexOf(c) !== -1)) return true;
        }
        return false;
      }
      for (i = 0; i < data.length; i++) {
        v = data[i];
        if (!v.available || v.opts[gi] !== val) continue;
        ok = true;
        for (j = 0; j < sel.length; j++) {
          if (j !== gi && sel[j] !== null && v.opts[j] !== sel[j]) { ok = false; break; }
        }
        if (ok) return true;
      }
      return false;
    }

    function altsIn(gi, sel, mode) {
      var out = [];
      if (gi < 0) return out;
      each(groups[gi].querySelectorAll('button[data-val]'), function (b) {
        var v = b.getAttribute('data-val');
        if (v !== sel[gi] && valueAvailable(gi, v, sel, mode)) out.push(v);
      });
      return out;
    }

    function markStock(sel, mode) {
      each(groups, function (g, gi) {
        var isColour = g === colourGroup;
        each(g.querySelectorAll('button[data-val]'), function (b) {
          var val = b.getAttribute('data-val');
          var ok = (mode === 'bundle' && g === sizeGroup) ? true : valueAvailable(gi, val, sel, mode);
          b.classList.toggle('is-soldout', !ok);
          if (isColour) b.setAttribute('aria-label', ok ? val : val + ' \u2013 udsolgt');
          var sr = b.querySelector('.scp-sr');
          if (sr) sr.textContent = ok ? '' : ' \u2013 udsolgt';
        });
        var flag = g.querySelector('[data-optstock]');
        if (flag) {
          var act = g.querySelector('button.active[data-val]');
          flag.hidden = !(act && act.classList.contains('is-soldout'));
        }
      });
    }

    function joinParts(gi, vals) {
      var out = [];
      vals.forEach(function (v, i) {
        if (i > 0) out.push(i === vals.length - 1 ? ' og ' : ', ');
        out.push({ gi: gi, val: v });
      });
      return out;
    }

    function hideNote() {
      if (!stockNote) return;
      stockNote.hidden = true;
      stockNote.innerHTML = '';
    }

    function renderNote(parts) {
      stockNote.innerHTML = '';
      var span = document.createElement('span');
      parts.forEach(function (p) {
        if (typeof p === 'string') { span.appendChild(document.createTextNode(p)); return; }
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'scp-stock-alt';
        btn.textContent = p.val;
        btn.addEventListener('click', function () {
          var b = groups[p.gi] ? findBtn(groups[p.gi], p.val) : null;
          if (b) b.click();
        });
        span.appendChild(btn);
      });
      stockNote.appendChild(span);
      stockNote.hidden = false;
    }

    function updateStockNote(sel, mode, target) {
      if (!stockNote) return;
      if (target && target.available) { hideNote(); return; }

      var ci = groupIndex(colourGroup), si = groupIndex(sizeGroup), alts, i, any = false;
      var parts = [];

      if (mode === 'duo') {
        if (!target) { hideNote(); return; }
        alts = altsIn(ci, sel, 'duo');
        parts.push(duoTitle + ' med ' + sortedPicks().map(shortSize).join(' + ') +
          (ci > -1 && sel[ci] ? ' i ' + sel[ci] : '') + ' er udsolgt lige nu.');
        if (alts.length) parts = parts.concat([' F\u00e5s stadig i '], joinParts(ci, alts), ['.']);
        renderNote(parts);
        return;
      }

      if (mode === 'bundle') {
        alts = altsIn(ci, sel, 'bundle');
        parts.push(bundleTitle + (ci > -1 && sel[ci] ? ' i ' + sel[ci] : '') + ' er udsolgt lige nu.');
        if (alts.length) parts = parts.concat([' F\u00e5s stadig i '], joinParts(ci, alts), ['.']);
        renderNote(parts);
        return;
      }

      for (i = 0; i < data.length; i++) { if (data[i].available) { any = true; break; } }
      if (!any) { renderNote(['Udsolgt i alle varianter lige nu.']); return; }

      var name = (si > -1 && ci > -1) ? sel[si] + ' i ' + sel[ci] : sel.filter(function (v) { return !!v; }).join(' \u00b7 ');
      parts.push(name + ' er udsolgt lige nu.');

      alts = altsIn(ci, sel, 'single');
      if (alts.length) {
        parts = parts.concat([' F\u00e5s stadig i '], joinParts(ci, alts), ['.']);
      } else {
        alts = altsIn(si, sel, 'single');
        if (alts.length) {
          parts = parts.concat([' ' + (ci > -1 ? sel[ci] + ' f\u00e5s' : 'F\u00e5s') + ' stadig i '], joinParts(si, alts), ['.']);
        }
      }
      renderNote(parts);
    }

    /* ---------- Galleri ---------- */
    var frames = root.querySelectorAll('.scp-frame');
    var thumbs = root.querySelectorAll('.scp-thumb');
    var strip = root.querySelector('[data-scp-thumbs]');
    var navPrev = root.querySelector('[data-scp-prev]');
    var navNext = root.querySelector('[data-scp-next]');

    function baseName(u) { return u ? u.split('?')[0].split('/').pop() : ''; }

    function hydrateFrame(f) {
      if (!f || f.getAttribute('src') || !f.dataset.src) return;
      if (f.dataset.srcset) f.setAttribute('srcset', f.dataset.srcset);
      f.src = f.dataset.src;
    }

    function hydrateNeighbours(idx) {
      hydrateFrame(frames[idx + 1]);
      hydrateFrame(frames[idx - 1]);
    }

    function setMain(src) {
      if (!src || !frames.length) return;
      var t = baseName(src), hit = false;
      each(frames, function (f, i) {
        var on = baseName(f.dataset.key) === t;
        if (on) {
          hit = true;
          hydrateFrame(f);
          hydrateNeighbours(i);
          if (countNow) countNow.textContent = f.dataset.vis || f.dataset.idx;
        }
        f.classList.toggle('is-on', on);
      });
      if (!hit) frames[0].classList.add('is-on');

      each(thumbs, function (x) {
        var on = baseName(x.dataset.img) === t;
        x.classList.toggle('active', on);
        if (on && strip) {
          var target = Math.max(0, x.offsetLeft - strip.clientWidth / 2 + x.offsetWidth / 2);
          if (Math.abs(strip.scrollLeft - target) > 8) strip.scrollTo({ left: target, behavior: 'smooth' });
        }
      });
    }

    /* Farvefiltrering: billeder mærket med en farve vises kun for den farve */
    function visibleThumbs() {
      var out = [];
      each(thumbs, function (t) { if (!t.hidden) out.push(t); });
      return out;
    }

    function filterGallery(colour) {
      if (!frames.length) return;
      var n = 0;
      each(frames, function (f) {
        var dc = f.getAttribute('data-colour');
        var off = !!(dc && colour && dc !== colour);
        f.classList.toggle('is-hidden', off);
        if (!off) { n++; f.dataset.vis = n; }
      });
      var m = 0;
      each(thumbs, function (t) {
        var dc = t.getAttribute('data-colour');
        var off = !!(dc && colour && dc !== colour);
        t.hidden = off;
        if (!off) m++;
      });
      if (countAll) countAll.textContent = n;
      var wrap = root.querySelector('.scp-thumbwrap');
      if (wrap) wrap.hidden = m < 2;
      syncNav();
    }

    each(thumbs, function (t) {
      t.addEventListener('click', function () { setMain(t.dataset.img); });
      t.addEventListener('mouseenter', function () {
        var t2 = baseName(t.dataset.img);
        each(frames, function (f) { if (baseName(f.dataset.key) === t2) hydrateFrame(f); });
      }, { passive: true });
    });

    /* Swipe mellem billederne på mobil */
    var mainEl = root.querySelector('.scp-main');
    if (mainEl && thumbs.length > 1) {
      var sx = 0, sy = 0, tracking = false;
      mainEl.addEventListener('touchstart', function (e) {
        if (!e.touches || e.touches.length !== 1) return;
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; tracking = true;
      }, { passive: true });
      mainEl.addEventListener('touchend', function (e) {
        if (!tracking || !e.changedTouches || !e.changedTouches.length) return;
        tracking = false;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
        var list = visibleThumbs();
        if (list.length < 2) return;
        var cur = 0;
        list.forEach(function (t, i) { if (t.classList.contains('active')) cur = i; });
        var next = (cur + (dx < 0 ? 1 : -1) + list.length) % list.length;
        setMain(list[next].dataset.img);
      }, { passive: true });
    }

    function syncNav() {
      if (!strip || !navPrev || !navNext) return;
      var max = strip.scrollWidth - strip.clientWidth;
      navPrev.hidden = strip.scrollLeft <= 2;
      navNext.hidden = strip.scrollLeft >= max - 2;
    }
    if (strip && navPrev && navNext) {
      var step = function () { return Math.max(strip.clientWidth * 0.8, 150); };
      navPrev.addEventListener('click', function () { strip.scrollBy({ left: -step(), behavior: 'smooth' }); });
      navNext.addEventListener('click', function () { strip.scrollBy({ left: step(), behavior: 'smooth' }); });
      strip.addEventListener('scroll', syncNav, { passive: true });
      window.addEventListener('resize', syncNav);
      syncNav();
    }

    /* ---------- Variantvalg ---------- */
    var sName = root.querySelector('[data-scp-s-name]');
    var sPrice = root.querySelector('[data-scp-s-price]');
    var sBtn = root.querySelector('[data-scp-s-btn]');
    var sThumb = root.querySelector('[data-scp-s-thumb]');

    function update() {
      var sel = chosen();
      var single = duoPage ? null : (data.length === 1 ? data[0] : findIn(data, sel));

      filterGallery(colourValue());

      if (single) {
        if (priceEl) priceEl.textContent = fmt(single.price);
        if (singlePrice) singlePrice.textContent = fmt(single.price);
        setMain(single.img);
      }

      var mode = offerMode();
      var target = mode === 'bundle' ? bundleVariant() : (mode === 'duo' ? duoVariant() : single);

      if (sizeGroup) {
        sizeGroup.classList.toggle('is-muted', mode === 'bundle');
        sizeGroup.classList.toggle('is-multi', mode === 'duo');
        if (sizeNote) sizeNote.classList.toggle('hidden', mode !== 'bundle');
        if (duoNote) duoNote.classList.toggle('hidden', mode !== 'duo');
      }

      markStock(sel, mode);
      updateStockNote(sel, mode, target);

      if (!target) {
        var waiting = mode === 'duo';
        var txt = waiting ? (duoPicks.length === 1 ? 'V\u00e6lg en st\u00f8rrelse mere' : 'V\u00e6lg 2 st\u00f8rrelser') : 'Ikke tilg\u00e6ngelig';
        if (idInput) idInput.disabled = true;
        if (addBtn) addBtn.disabled = true;
        if (addText) addText.textContent = txt;
        if (addPrice) addPrice.textContent = (waiting && duoData.length) ? fmt(duoData[0].price) : '';
        if (sBtn) { sBtn.disabled = true; sBtn.textContent = txt; }
        if (sName) sName.textContent = waiting ? duoTitle : productTitle;
        return;
      }

      idInput.value = target.id;
      idInput.disabled = false;
      addBtn.disabled = !target.available;
      addText.textContent = target.available ? addLabel : 'Udsolgt';
      addPrice.textContent = target.available ? fmt(target.price) : '';

      var label;
      if (mode === 'bundle') {
        label = bundleTitle + (colourValue() ? ' \u00b7 ' + colourValue() : '');
      } else if (mode === 'duo') {
        label = duoTitle + ' \u00b7 ' + sortedPicks().map(shortSize).join(' + ') + (colourValue() ? ' \u00b7 ' + colourValue() : '');
      } else {
        var parts = sel.filter(function (v) { return !!v; });
        label = parts.length ? parts.join(' \u00b7 ') : productTitle;
      }
      if (sName) sName.textContent = label;
      if (sPrice) sPrice.textContent = fmt(target.price);
      if (sBtn) {
        sBtn.disabled = !target.available;
        sBtn.textContent = target.available ? addLabel : 'Udsolgt';
      }
      if (sThumb && target.thumb) sThumb.src = target.thumb;
    }

    function firstAvailableColour(list) {
      for (var i = 0; i < list.length; i++) {
        if (!list[i].available) continue;
        var opts = list[i].opts, pick = null;
        each(colourGroup.querySelectorAll('button[data-val]'), function (b) {
          if (!pick && opts.indexOf(b.getAttribute('data-val')) !== -1) pick = b.getAttribute('data-val');
        });
        if (pick) return pick;
      }
      return null;
    }

    function onOfferChange() {
      var mode = offerMode();

      if (mode === 'duo') {
        if (!duoPicks.length) {
          var a = activeSizeVal();
          if (a) duoPicks = [a];
        }
        paintDuo();
      } else if (prevMode === 'duo' && sizeGroup) {
        var last = duoPicks[duoPicks.length - 1] || activeSizeVal();
        if (last) selectValue(sizeGroup, last);
      }

      if (mode === 'bundle' && colourGroup && bundleData.length) {
        var bv = bundleVariant();
        if (bv && !bv.available) {
          var pick = firstAvailableColour(bundleData);
          if (pick) selectValue(colourGroup, pick);
        }
      }

      prevMode = mode;
      update();
      refreshPick();
    }

    each(root.querySelectorAll('.scp-offers input'), function (r) {
      r.addEventListener('change', onOfferChange);
    });

    each(groups, function (g) {
      each(g.querySelectorAll('button[data-val]'), function (b) {
        b.addEventListener('click', function () {
          var val = b.getAttribute('data-val');
          if (g === sizeGroup && offerMode() === 'duo') {
            var idx = duoPicks.indexOf(val);
            if (idx !== -1) {
              duoPicks.splice(idx, 1);
            } else {
              duoPicks.push(val);
              if (duoPicks.length > 2) duoPicks.shift();
            }
            paintDuo();
          } else {
            selectValue(g, val);
          }
          update();
          if (g === sizeGroup) syncTabs(keyOf(val));
        });
      });
    });

    /* ---------- Størrelsessektion ---------- */
    var vis = root.querySelector('[data-scp-cfg-vis]');
    var cfgKey = '2';
    var pickBtn = root.querySelector('[data-scp-cfg-pick]');
    var pickText = root.querySelector('[data-scp-cfg-pick-text]');
    function setCfg() {}
    function syncTabs() {}
    function refreshPick() {
      if (!pickBtn || !pickText || !sizeGroup || !allowPick) return;
      var picked = keyOf(activeSizeVal()) === cfgKey && offerMode() === 'single';
      pickBtn.classList.toggle('is-picked', picked);
      pickText.textContent = picked ? 'Valgt \u2014 g\u00e5 til k\u00f8b' : 'V\u00e6lg denne st\u00f8rrelse';
    }

    if (vis) {
      var CFG = {
        '2': { lab: 'Stort format', title: 'Middags-mesteren', rooms: 2, vol: '500 ml', total: '1000 ml', cols: 2, desc: 'Perfekt til store portioner suppe, gryderetter eller lasagne. \u00c9t rum svarer til et m\u00e6ttende voksenm\u00e5ltid.', uses: ['Supper og sammenkogte retter', 'Hele m\u00e5ltider til \u00e9n person', 'Meal prep baser'] },
        '3': { lab: 'Hverdagsformat', title: 'Hverdags-helten', rooms: 3, vol: '350 ml', total: '1050 ml', cols: 3, desc: 'Den alsidige st\u00f8rrelse til daglig brug \u2014 portioner der passer til frokost, rester og forberedte m\u00e5ltider.', uses: ['Frokostportioner', 'Rester fra aftensmaden', 'Gr\u00f8d og morgenmad'] },
        '4': { lab: 'Mellemformat', title: 'Tilbeh\u00f8rs-talentet', rooms: 4, vol: '250 ml', total: '1000 ml', cols: 2, desc: 'Til tilbeh\u00f8r og mindre portioner \u2014 n\u00e5r et helt m\u00e5ltid er for meget, men en klat er for lidt.', uses: ['Ris, kartofler og tilbeh\u00f8r', 'Mindre portioner', 'Smoothies'] },
        '6': { lab: 'Lille format', title: 'Detalje-eksperten', rooms: 6, vol: '150 ml', total: '900 ml', cols: 3, desc: 'Til de sm\u00e5 m\u00e6ngder, hvor pr\u00e6cision t\u00e6ller \u2014 sovs, fond, pesto og babymad. T\u00f8 kun det op, du skal bruge.', uses: ['Sovs, fond og pesto', 'Hjemmelavet babymad', 'Krydderurter i olie'] }
      };
      var photo = root.querySelector('[data-scp-cfg-photo]');
      var tray = root.querySelector('[data-scp-tray]');

      if (pickBtn && sizeGroup && allowPick) pickBtn.classList.remove('hidden');

      var drawTray = function (n, cols) {
        tray.style.gridTemplateColumns = 'repeat(' + cols + ',1fr)';
        tray.innerHTML = '';
        for (var i = 0; i < n; i++) {
          var c = document.createElement('div');
          c.className = 'scp-cell';
          c.style.animationDelay = (i * 0.06) + 's';
          tray.appendChild(c);
        }
      };

      setCfg = function (k) {
        var d = CFG[k];
        if (!d) return;
        cfgKey = k;
        if (cfgImg && cfgImg[k]) { photo.src = cfgImg[k]; vis.classList.add('has-photo'); }
        else { vis.classList.remove('has-photo'); photo.removeAttribute('src'); drawTray(d.rooms, d.cols); }
        root.querySelector('[data-cfg-lab]').textContent = d.lab;
        root.querySelector('[data-cfg-title]').textContent = d.title;
        root.querySelector('[data-cfg-desc]').textContent = d.desc;
        root.querySelector('[data-cfg-rooms]').textContent = d.rooms;
        root.querySelector('[data-cfg-vol]').textContent = d.vol;
        root.querySelector('[data-cfg-total]').textContent = d.total;
        var ul = root.querySelector('[data-cfg-uses]');
        ul.innerHTML = '';
        d.uses.forEach(function (u) {
          var li = document.createElement('li');
          li.textContent = u;
          ul.appendChild(li);
        });
        refreshPick();
      };

      syncTabs = function (k) {
        if (!k || !CFG[k]) return;
        each(root.querySelectorAll('.scp-cfg-tab'), function (t) {
          t.classList.toggle('active', t.dataset.cfg === k);
        });
        setCfg(k);
      };

      each(root.querySelectorAll('.scp-cfg-tab'), function (t) {
        t.addEventListener('click', function () {
          each(root.querySelectorAll('.scp-cfg-tab'), function (x) { x.classList.remove('active'); });
          t.classList.add('active');
          setCfg(t.dataset.cfg);
        });
      });

      if (pickBtn && allowPick) {
        pickBtn.addEventListener('click', function () {
          var singleRadio = root.querySelector('.scp-offers input[data-offer="single"]');
          if (singleRadio) singleRadio.checked = true;
          prevMode = 'single';
          duoPicks = [];
          if (sizeGroup) {
            each(sizeGroup.querySelectorAll('button[data-val]'), function (b) {
              var on = keyOf(b.getAttribute('data-val')) === cfgKey;
              b.classList.toggle('active', on);
              b.setAttribute('aria-pressed', on ? 'true' : 'false');
            });
          }
          update();
          refreshPick();
          var target = root.querySelector('.scp-info') || addBtn;
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }

      syncTabs(keyOf(activeSizeVal()) || '2');
    }

    /* ---------- Afsluttende CTA ---------- */
    var finalCta = root.querySelector('[data-scp-final-cta]');
    if (finalCta) {
      finalCta.addEventListener('click', function () {
        var b = root.querySelector('.scp-offers input[data-offer="bundle"]');
        if (b && !b.disabled) { b.checked = true; onOfferChange(); }
        var target = root.querySelector('.scp-info') || addBtn;
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    /* ---------- Fastlåst købslinje ---------- */
    var sticky = root.querySelector('[data-scp-sticky]');
    if (sticky && addBtn && sBtn) {
      sBtn.addEventListener('click', function () { addBtn.click(); });
      var sio = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          sticky.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0);
        });
      }, { threshold: 0 });
      sio.observe(addBtn);
    }

    /* ---------- Indtoning ---------- */
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    each(root.querySelectorAll('.scp-reveal'), function (el) { io.observe(el); });

    update();

    var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 1200); };
    idle(function () {
      for (var i = 0; i < frames.length; i++) {
        if (frames[i].classList.contains('is-on')) { hydrateNeighbours(i); break; }
      }
    });

    if (strip) {
      var act = strip.querySelector('.scp-thumb.active');
      if (act) strip.scrollLeft = Math.max(0, act.offsetLeft - strip.clientWidth / 2 + act.offsetWidth / 2);
      syncNav();
    }
  }

  function boot() {
    each(document.querySelectorAll('[data-scp]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
